commonModule.factory('erateSessionVarsService', ['$http', 'AppSettings', '$window', '$q', 'commonRESTCallService',
    function ($http, AppSettings, $window, $q, commonRESTCallService) {
    var erateSessionVarsSvc = {};

    erateSessionVarsSvc.getCurrentDealerSPANId = function() {
        var spanId = $window.sessionStorage.getItem('SESS_DEALER_SPAN_ID');

        return spanId;
    };

    erateSessionVarsSvc.setCurrentDealerSPANId = function(spanId) {
        $window.sessionStorage.setItem('SESS_DEALER_SPAN_ID', spanId);
    };

    erateSessionVarsSvc.getCurrentDealerMenuProId = function() {
        return $window.sessionStorage.getItem('SESS_DEALER_MENUPRO_ID');
    };

    erateSessionVarsSvc.setCurrentDealerMenuProId = function(menuProId) {
        $window.sessionStorage.setItem('SESS_DEALER_MENUPRO_ID', menuProId);
    };

    erateSessionVarsSvc.getCurrentDealerAccountCode = function() {
        var acct = $window.sessionStorage.getItem('SESS_DEALER_ACCOUNT_CODE');
        return acct;
    };

    erateSessionVarsSvc.setCurrentDealerAccountCode = function(accountCode) {
        $window.sessionStorage.setItem('SESS_DEALER_ACCOUNT_CODE', accountCode);
    };

    erateSessionVarsSvc.getCurrentDealerVehicleType = function() {
        var vType = $window.sessionStorage.getItem('SESS_DEALER_VEHICLE_TYPE');
        return vType;
    };

    erateSessionVarsSvc.setCurrentDealerVehicleType = function(vehicleType) {
        $window.sessionStorage.setItem('SESS_DEALER_VEHICLE_TYPE', vehicleType);
    };

   erateSessionVarsSvc.getProviderLogoutUrl = function() {
        // If not null, UI will redirect to this URL whenever the user logs out - used for provider portals
        var url = $window.sessionStorage.getItem('SESS_PROVIDER_LOGOUT_URL');
        if (!(url && url != 'null'))
            return null;
        return url;
    };


   erateSessionVarsSvc.setDealerState = function(dealerState) {
       $window.sessionStorage.setItem('SESS_DEALER_STATE', dealerState);
   };

   erateSessionVarsSvc.getDealerState = function() {
       //get dealership state
       var dealerState = $window.sessionStorage.getItem('SESS_DEALER_STATE');
       return dealerState;
   };

    erateSessionVarsSvc.setProviderLogoutUrl = function(url) {
        $window.sessionStorage.setItem('SESS_PROVIDER_LOGOUT_URL', url);
    };

    erateSessionVarsSvc.getQuotingMode = function() {
        return $window.sessionStorage.getItem('SESS_QUOTE_MODE');
    };

    erateSessionVarsSvc.setQuotingMode = function(quoteMode) {
        $window.sessionStorage.setItem('SESS_QUOTE_MODE', quoteMode);
    };

    erateSessionVarsSvc.getIntegrationToken = function() {
        var tok = $window.sessionStorage.getItem('SESS_INT_TOKEN');
        return tok;
    };

    erateSessionVarsSvc.setIntegrationToken = function(tok) {
        $window.sessionStorage.setItem('SESS_INT_TOKEN', tok);
    };

    erateSessionVarsSvc.getDealerAltFinanceEnabled = function() {
        if ($window.sessionStorage.getItem('SESS_DEALER_ALT_FINANCE_ON')){
            return $window.sessionStorage.getItem('SESS_DEALER_ALT_FINANCE_ON').toUpperCase() == "TRUE";
        }else { return false; };
    }

    erateSessionVarsSvc.setDealerAltFinanceEnabled = function(altFinanceOn) {
        $window.sessionStorage.setItem('SESS_DEALER_ALT_FINANCE_ON', altFinanceOn.toString());
    };

    return erateSessionVarsSvc;
}]);
